import React, { Component } from "react";
import Table from "../common/table/table";
import config from "../../config.json";

const imagesUrl = config.imagesUrl;

class StatsTable extends Component {
  columns = [
    {
      key: "team",
      label: "Team",
      className: "col-6",
      content: stats => (
        <span>
          <img
            src={imagesUrl + stats.team.logo}
            alt={stats.team.name}
            title={stats.team.name}
            className="team-logo-small"
          />
          &nbsp;&nbsp;
          {stats.team.name}
        </span>
      )
    },
    {
      key: "pointsHome",
      label: "Home",
      className: "col-2 right",
      content: stats => <span>{stats.pointsHome}</span>
    },
    {
      key: "pointsAway",
      label: "Away",
      className: "col-2 right",
      content: stats => <span>{stats.pointsAway}</span>
    },
    {
      key: "points",
      label: "Total",
      className: "col-2 right",
      content: stats => <span>{stats.pointsHome + stats.pointsAway}</span>
    }
  ];

  render() {
    const { stats } = this.props;

    if (stats.length > 0) {
      return (
        <div className="container">
          <Table columns={this.columns} data={stats} />
        </div>
      );
    }
    return null;
  }
}

export default StatsTable;



// WEBPACK FOOTER //
// ./src/components/stats/statsTable.jsx